import { Product } from 'src/app/@utils/gtm-tracking/model/Product';
import { mapToBasketTrackableProduct } from 'src/app/@utils/gtm-tracking/utils/mapToBasketTrackableProduct';

import { BasketLine } from '@models/api-orders.models';

export type CheckoutBeginEvent = {
    event: 'begin_checkout';
    ecommerce: {
        currency: string;
        value: number;
        coupon?: string;
        items: Product[];
    };
};

export const trackCheckoutBeginEvent = (
    products: BasketLine[],
    basketValue: number = 0,
    coupon: string[] = [],
    currency: string = 'DKK'
): CheckoutBeginEvent => ({
    event: 'begin_checkout',
    ecommerce: {
        currency,
        coupon: coupon.join(', '),
        value: basketValue,
        items: products.map(product => mapToBasketTrackableProduct(product))
    }
});
